import React from 'react'
import classNames from 'classnames'
import { BadgeProps } from './Badge.d'
import TextIcon from '@toasttab/shared/src/components/molecules/TextIcon/TextIcon'

const Badge = ({
  badgeColor,
  text,
  uppercase = false,
  disabled = false,
  classes,
  icon
}: BadgeProps) => {
  badgeColor = disabled ? 'bg-gray-0' : badgeColor
  const badgeClasses = classNames(
    classes,
    badgeColor,
    {
      'type-badge text-center rounded-badge inline-block font-semibold': true,
      '!uppercase': uppercase,
      'text-default':
        badgeColor !== 'bg-gray-125' &&
        badgeColor !== 'bg-gray-110' &&
        badgeColor !== 'bg-sky-0' &&
        !disabled,
      'text-white':
        (badgeColor === 'bg-gray-125' || badgeColor === 'bg-gray-110') &&
        !disabled,
      'text-disabled': badgeColor === 'bg-gray-0' && disabled
    },
    {
      '!uppercase px-2 py-1': uppercase,
      'px-3 py-[5px]': !uppercase
    }
  )

  if (icon) {
    icon = icon ? icon : 'schedule'
  }

  return (
    <div className={badgeClasses}>
      {icon && <TextIcon icon={icon} text={text} size='sm' />}
      {!icon && text}
    </div>
  )
}

export default Badge
